<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5">
    <loading v-if="loading" />
    <div class="container whiteCont mt-5 mb-5">
      <div class="row justify-content-center verticalCentred">
        <div class="col-6 mt-5 pt-5">
          <h2 class="mb-5 center" v-model="result" type="text">{{ result }}</h2>
          <div v-if="status" class="mt-5 center">
            <router-link v-if="corporateClient != 'hoval'" class="btn btn-primary btn-lg" to="/login"
              >Accedi</router-link
            >
						<router-link v-else class="btn btn-primary btn-lg" to="/"
              >Home</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
export default {
  name: "confirm",
  components: {},
  data() {
    return {
      result: "Verifica Token",
      status: false,
      loading: false,
			corporateClient:''
    };
  },
  methods: {
    confirm: function () {
      const token = this.$route.query.token;
      if (token) {
        this.loading = true;
        var data = {
          token: token,
        }
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        axios({
          url: process.env.ROOT_API + "fapi/confirmAccount",
          data: { data },
          method: "POST",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
						resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
						this.corporateClient = resp.data.user.corporateClient
            this.status = true;
            this.loading = false;
						if(this.corporateClient != 'hoval'){
							this.result = "Il tuo account è stato attivato.";
						}else{
							this.result = "Hai correttamente confermato la tua email, non appena il tuo account verrá verificato riceverai una email di conferma."
						}
            
          })
          .catch((resp) => {
            this.loading = false;
            this.result = process.env.MSG_CONFIRM_TOKEN_NOT_FOUND;
          });
      } else {
        this.result = process.env.MSG_CONFIRM_TOKEN_NOT_FOUND;
      }
    },
  },
  beforeMount() {
    this.confirm();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/confirm/index.vue